<div v-if="banners && banners.length > 0" v-html=banners[0].content> </div>